import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
    selector: 'blur-document',
    templateUrl: 'blur-document.component.html',
    styleUrls: ["blur-document.component.scss"],
    standalone: false
})
export class BlurDocumentComponent implements OnInit {
	@Input() public model: any;
	@Input() public isEFacturaPdf: any;

	@Output() public save = new EventEmitter();
	@Output() public close = new EventEmitter();

	public get reasonCode(): string {
		return this.model?.reasonCode;
	}
	public set reasonCode(value: string) {
		if (this.model && this.model.reasonCode != value) {
			this.model.reasonCode = value;
			switch (this.model.reasonCode) {
				case 'neclar':
					this.model.comment = 'Documentul este neclar și nu poate fi citit. Te rog să refaci poza.';
					break;
				case 'irelevant':
					this.model.comment = 'Acest document nu este necesar pentru înregistrările contabile (ex: avize, contracte, confirmări de plată, registre de încasări etc.). Pentru o evidență eficientă, vă rugăm să reanalizați sau să ștergeți documentul, încărcând doar pe cele cu implicații contabile directe. Pentru mai multe informații, scrieți-ne pe Connect/Contabilitate.';
					break;
				case 'non-eFactura':
					this.model.comment = 'Acest document este o factură de achiziție non e-Factură cu data mai mare de 01 Iulie 2025. Aceste documente nu mai sunt considerate documente contabile și nu se mai pot înregistra.\nVă rugăm să ștergeți acest document.\nPentru a încărca factura trebuie să intrați în meniul Facturare/e-Factură/Inbox și să trimiteți în contabilitate facturile.\nMai multe detalii aici: https://app.keez.ro/help/client/inregistrare/keez_primii_pasi/cum_se_incarca_documente_facturi_cumparare_eFactura.html';
					break;
				default:
					this.model.comment = '';
			}
		}
	}

	constructor() { }

	public ngOnInit() {
		setTimeout(() => {
			$('#txtComment textarea').focus();
		}, 100);
	}

}
